<center-modal [modal]="modal" style="border-radius: 5px; width: 100%; height: 100%; background: var(--background)">
  <ion-header>
    <ion-toolbar>
      <ion-title>
        Reconcile Transaction
      </ion-title>
    </ion-toolbar>
  </ion-header>
  <div class="content">

    <div class="heading">
      This system will now seek to find a match for the transaction you have selected. Select options below to find the appropriate match
    </div>

    <table>
      <tr>
        <th class="text-left">Date</th>
        <th class="text-left">Narration</th>
        <th class="text-right">Transaction</th>
        <th class="text-right">Balance</th>
      </tr>
      <tr>
        <td class="text-left">{{transaction.date | date:'dd/MM/yy'}}</td>
        <td class="text-left">{{transaction.narration}}</td>
        <td class="text-right">{{transaction.transaction | currency}}</td>
        <td class="text-right">{{transaction.bankBalance | currency}}</td>
      </tr>
      <tr *ngIf="indeterminate || allSelected">
        <td colspan="2">
          Selected Total: <b>{{ (results | sumField : 'called' : selected) | currency }}</b>
        </td>
        <td class="text-right" [class.green]="(transaction.transaction - (results | sumField : 'called' : selected) + (results | sumField : 'received' : selected) + existingRecon) | smallNumber" [class.red]="!((transaction.transaction - (results | sumField : 'called' : selected) + (results | sumField : 'received' : selected) + existingRecon) | smallNumber)">
          Selected Unfunded: <b>{{ ((results | sumField : 'called' : selected) - (results | sumField : 'received' : selected) - existingRecon) | currency }}</b>
        </td>
        <td class="text-right">
          Shortfall: <b>{{ ((-transaction.transaction + (results | sumField : 'called' : selected)) - (results | sumField : 'received' : selected) - existingRecon) | currency }}</b>
        </td>
      </tr>
    </table>

    <ng-container *ngIf="!matching">
      <div class="heading">
        Select the dates to search for the relevant call:
      </div>
  
      <div class="date-range">
        <!-- Nominate some start and end date for the relevant call -->
        <div class="date">
          <span>Start</span>
          <ion-datetime-button datetime="start"></ion-datetime-button>
        </div>
  
        <div class="date">
          <span>End</span>
          <ion-datetime-button datetime="end"></ion-datetime-button>
        </div>
        
  
        <ion-modal [keepContentsMounted]="true">
          <ng-template>
            <ion-datetime id="start" displayFormat="DD/MM/YYYY" [(ngModel)]="startDate" presentation="date"></ion-datetime>
          </ng-template>
        </ion-modal>
  
  
        <ion-modal [keepContentsMounted]="true">
          <ng-template>
            <ion-datetime id="end" displayFormat="DD/MM/YYYY" [(ngModel)]="endDate" presentation="date"></ion-datetime>
          </ng-template>
        </ion-modal>
      </div>
  
      <div class="heading">
        Enter filter keys below (blank will return all queries)
      </div>
  
      <div class="search-string">
        <ion-item>
          <ion-label position="stacked">Deal Name</ion-label>
          <ion-input [(ngModel)]="searchKeys.dealName" placeholder="e.g. FST123"></ion-input>
        </ion-item>
  
        <ion-item>
          <ion-label position="stacked">Entity ID</ion-label>
          <ion-input [(ngModel)]="searchKeys.entityId" placeholder="e.g. C1234"></ion-input>
        </ion-item>
  
        <ion-item>
          <ion-label position="stacked">Entity Name</ion-label>
          <ion-input [(ngModel)]="searchKeys.entityName" placeholder="e.g. John Smith atf The John Smith Trust"></ion-input>
        </ion-item>
  
        <ion-item>
          <ion-label position="stacked">Bank Code</ion-label>
          <ion-input [(ngModel)]="searchKeys.bankCode" placeholder="e.g. 123456789"></ion-input>
        </ion-item>
  
        <ion-item>
          <ion-label position="stacked">$ Amount</ion-label>
          <ion-input [(ngModel)]="searchKeys.called" placeholder="e.g. 1234.56"></ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">Unfunded Only?</ion-label>
          <ion-toggle [(ngModel)]="unfunded"></ion-toggle>
        </ion-item>
      </div>

      <div class="buttons">
        <ion-button color="danger" (click)="dismissModal()">
          Cancel
        </ion-button>
        <ion-button color="success" (click)="searchCalls()">
          Search
        </ion-button>
      </div>
    </ng-container>

    <ng-container *ngIf="matching">
      <ng-container *ngIf="loading">
        <div class="center-div">
          <ion-spinner></ion-spinner>
        </div>
      </ng-container>

      <ng-container *ngIf="!loading">

        <div class="heading">
          <b>Results (total {{results?.length | number}}, {{(selected | filterVals : true)?.length | number }} Selected):</b>
        </div>
  
        <table>
          <tr>
            <th>
              <div class="center-div">
                <ion-checkbox [indeterminate]="indeterminate" [checked]="allSelected" (ionChange)="selectAll($event)"></ion-checkbox>
              </div>
            </th>
            <th class="text-left">Mandate Call</th>
            <th class="text-left">Entity ID</th>
            <th class="text-left">Deal Name</th>
            <th class="text-left">Entity Name</th>
            <th class="text-center">Call Date</th>
            <th class="text-right">Amount Called</th>
            <th class="text-right">Amount Received</th>
          </tr>
          <tr *ngFor="let result of results; let i = index" [class.selected]="selected[i]">
            <td>
              <div class="center-div">
                <ion-checkbox [(ngModel)]="selected[i]" (ionChange)="checkSelection()"></ion-checkbox>
              </div>
            </td>
            <td class="text-left">{{callUrls[result.callUrl]}}</td>
            <td class="text-left">{{result.entityId}}</td>
            <td class="text-left">{{result.dealName}}</td>
            <td class="text-left">{{result.entityName}}</td>
            <td class="text-center">{{result.date | date:'dd/MM/yy'}}</td>
            <td class="text-right">{{result.called | currency}}</td>
            <td class="text-right">
              {{result.received + ((((investorRecon | filterPropVals : 'dealName' : result.dealName) | filterPropVals : 'entityId' : result.entityId) | filterPropVals : 'index' : result.index) | sumField : 'amount') | currency}}
            </td>
          </tr>
        </table>

        <div class="buttons">
          <ion-button color="danger" (click)="matching = false">
            Back
          </ion-button>
          <ion-button color="success" (click)="reconcile()" [disabled]="!(selected | filterVals : true)?.length">
            Confirm
          </ion-button>
        </div>
      </ng-container>

    </ng-container>


    
  </div>
</center-modal>